import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const { colorTextMedium, space1, space4, space6 } = theme();

  return StyleSheet.create({
    brand: {
      color: colorTextMedium,
    },
    container: {
      width: "100%",
    },
    content: {
      flex: 1,
      gap: space1,
    },
    info: {
      display: "flex",
      flexDirection: "row",
      marginBottom: space4,
    },
    smallContainer: {
      paddingHorizontal: space6,
    },
  });
};

export { style };
